import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import { NavLink } from "react-router-dom"
import { Variables } from "../../Variations/Variations"
import { BiTrash, BiEdit, BiShowAlt, BiHide } from 'react-icons/bi'
import { ToastContainer, toast } from 'react-toastify';
import Util from "../../Classes/Util";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { RiDeleteBinLine } from 'react-icons/ri';
import {
  AiOutlineClose, AiOutlineCheck,
  AiOutlineRight,
} from 'react-icons/ai';
import { Button, Modal } from "react-bootstrap";


const AllPages = () => {
  const [listPages, setListPages] = useState([]);
  const [show, setShow] = useState(0)
  const columns = [
    {
      name: 'ID',
      selector: row => row.Id
    },
    {
      name: 'Page Title',
      selector: row => row.Name,
      sortable: true,
      reorder: true,
    },
  ];

 

  async function GetPages() {
    const URL = Variables.API_URL + "Rasha/Page/Get";
    const response = await fetch(URL)
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setListPages(listItems);
  }
  //#region Use Effect 
  useEffect(() => {
    GetPages();
  }, [])
  //#endregion Use Effect 
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Pages</h2>
            <ul className="portalPath">
              <li>Home <AiOutlineRight /></li>
              <li>List Pages</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
             
              <div className="card-body">
                <div className="portalTable">
                  <DataTable
                    columns={columns}
                    data={listPages}
                    pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick />
      </div>
    </div>
  )
}
export default AllPages;